<template>
    <form-create :rule="rule" v-model="fApi" :option="options"/>
</template>

<script>
import formCreate, { maker } from "@form-create/element-ui";
    export default {
        components: {
    formCreate: formCreate.$form()
  },
        data(){
            return {
                fApi:{},
                options:{
                    onSubmit:(formData)=>{
                        alert(JSON.stringify(formData))
                    }
                },
                rule:[
                    {
                        type:'input',
                        field:'inputField2',
                        title:'click 事件',
                        nativeEmit:['click'],
                    }
                ]
            }
            
        },
        methods:{
            click(){
                alert(`click!!"点击了"`)
            }
        },
        mounted(){
            this.fApi.on('native-input-field2-click',this.click)
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/utility/test.vue